module.exports = {
    URL_API: process.env.REACT_URL_API || "https://api.icollect-iag.com/api",
    //URL_API: process.env.REACT_URL_API || "http://127.0.0.1:8000/api",
    URL_REF: "",
    SOCKET_URL:process.env.REACT_SOCKET_URL || "http://127.0.0.1:9999",
    MAP_TOKEN:"pk.eyJ1IjoiZWxpZXRtc29mdCIsImEiOiJjbGE2dDFtN2YwazV5M3FxejZodXVoaHYwIn0.LhTKf_1UtkoK2N_9gpxQ9w"
  };  

  